module.exports = __webpack_public_path__ + "static/img/wxScrap.1642add.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wxScrap.png
// module id = djPT
// module chunks = 1